import { Component, OnInit,ViewChild } from '@angular/core';
import {StatusService} from '../../../services/status.service';
import {DataSellGoods} from '../../../data/data-sell-goods';
import { HttpHeaders,HttpClient} from '@angular/common/http';
import {AppSettings} from '../../../app-settings';
import {DbService} from '../../../services/db.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import {Router} from '@angular/router';
import {Resp} from '../../../models/resp';
import {RespSavedDocument} from '../../../models/resp-saved-document';


@Component({
  selector: 'app-sell-goods',
  templateUrl: './sell-goods.component.html',
  styleUrls: ['./sell-goods.component.css'],
  providers: [DbService]
})
export class SellGoodsComponent implements OnInit {

  @ViewChild('sellgoodsForm',{static:false}) form;

	private disableForm=false;
	private hideSuccessMessage=true;

  public statusMsg;


  private dataSellGoods=new DataSellGoods();

  checkAccess(){
    if(!this.statusService.getAccess()){
        this.router.navigate(['']);
    }
  }

  ngOnInit() {
    this.checkAccess();
  	this.dataSellGoods=this.statusService.getSellGoods();
      let idB=this.statusService.getIdBeneficiario();
    if(idB==undefined){
      window.alert('seleziona un beneficiario prima di iniziare a produrre un documento');
      this.router.navigate(['/dashboard'])
    }
  }
  showUpdateButton(){
    return this.statusService.updateDoc('SELLGOODS');
  }

    updateMessage(){
    this._flashMessagesService.show(this.statusMsg, { cssClass: 'alert-success', timeout: 3700 });
    console.warn("updateMessage()");
  }
  saveData(){
      this.statusService.setNewDoc('SELLGOODS');
  	console.log(this.form.valid);
  	if(this.form.valid){
  		this.disableForm=true;
  		this.hideSuccessMessage=false;
  		this.statusService.updateSellGoods(this.dataSellGoods);
      this.statusService.setPrintSellGoods(true);
      this.statusPrintSellGoods=this.statusService.getSellGoods().print;
      this.statusMsg="campi impostati correttamente";
      this.updateMessage();
  	}




  }

  updateData(){
      if(this.form.valid){
        this.disableForm=true;
        this.hideSuccessMessage=false;
        this.statusService.updateSellGoods(this.dataSellGoods);
        this.statusService.setPrintSellGoods(true);
        this.statusPrintSellGoods=this.statusService.getSellGoods().print;
        this.statusMsg="campi aggiornati correttamente";
      this.updateMessage();
      }
  }


  enableForm(){
       this.hideSuccessMessage=true;
       this.disableForm=false;
       this.statusMsg="documento pronto per essere modificato";

       this.updateMessage();



    }

   activateForm(){
       this.hideSuccessMessage=true;
       this.disableForm=false;

     }

    clear(){
        this.statusService.updateSellGoods(new DataSellGoods());
        this.statusService.setPrintSellGoods(false);
        this.statusService.setViewSellGoods(false);
        this.statusPrintSellGoods=this.statusService.getSellGoods().print;
        this.statusViewSellGoods=this.statusService.getSellGoods().view;
        this.dataSellGoods=this.statusService.getSellGoods();
        this.activateForm();
        this.statusMsg="nuovo documento generato con successo";
        this.updateMessage();
    }


    /* roba spostata da document-icon-sell-imm */

  public statusPrintSellGoods:boolean;
  public statusViewSellGoods:boolean;


  private ads;
  private bene;
  private obj;
   public showWhere:string;

   constructor(private router:Router,private _flashMessagesService: FlashMessagesService,public statusService:StatusService,public dbService:DbService, public http:HttpClient) {


    this.statusPrintSellGoods=statusService.getSellGoods().print;
      console.log("statusPrint: ",this.statusPrintSellGoods);
      this.statusViewSellGoods=statusService.getSellGoods().view;
      console.log("statusView:",this.statusViewSellGoods);
  }




  setAds(a){

    //2
    this.ads=a;
    console.log(this.ads);

      this.dbService.getBeneficiario(this.statusService.getIdBeneficiario())

      .subscribe(data => this.setBene((data as Resp).data));
  }

  setBene(b){
    //3
    this.bene=b;
    console.log(this.bene);
    //faccio chiamata a libreria per creare pdf

    var data = {"ads":JSON.stringify(this.ads),"bene":JSON.stringify(this.bene),"obj":JSON.stringify(this.obj), "id":this.statusService.getId()};

    var json=JSON.stringify(data);

      /*var params=json;
    let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('ads', );
        urlSearchParams.append('bene', this.bene.json());
        urlSearchParams.append('fields', this.obj.json());
        let params = urlSearchParams.toString();*/

        console.log(json);
        var headers=new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
       return this.http.post(`${AppSettings.API_ENDPOINT}/php/documents/${AppSettings.TRIBUNAL_ENDPOINT}/sellgoods.php`,json,{headers:headers})

         .subscribe(data => this.showDocument(data));
  }

  showDocument(data){

    this.showWhere=data.fileName;
    this.statusService.setViewSellGoods(true);
    this.statusViewSellGoods=this.statusService.getSellGoods().view;
    this.statusMsg="documento generato con successo";
    this.updateMessage();


  }

  print(){

    //1


     this.obj=this.statusService.getSellGoods();
    this.dbService.getAmministratore(this.statusService.getId())

      .subscribe( data => this.setAds((data as Resp).data));




    console.log("print() called()");
    console.log(this.obj);


  }



  save(){
    console.log("ho chiamato il metodo save: ");
  this.obj=this.statusService.getSellGoods();

  //console.log(this.obj);

   var update= this.statusService.updateDoc('SELLGOODS');
    var data;
    var json;



   if(update){
      let idDoc=this.statusService.getIdDocToSave();
      data = {"obj":JSON.stringify(this.obj), "id":this.statusService.getId(),"idDoc":idDoc,"kind":"SELLGOODS","idBeneficiario":this.statusService.getIdBeneficiario()};
      json=JSON.stringify(data);
     this.dbService.update2db(json)

       .subscribe(data => this.showSuccessMsg(data));

    }else
    {
      data = {"obj":JSON.stringify(this.obj), "id":this.statusService.getId(),"kind":"SELLGOODS","idBeneficiario":this.statusService.getIdBeneficiario()};
      console.log("sono su ramo save (non update), salverò: ",data);
      json=JSON.stringify(data);
       this.dbService.save2db(json)

         .subscribe(data =>{
           if((data as RespSavedDocument).id!=-1){
            this.statusService.updateIdDocToSave((data as RespSavedDocument).id);
          }

         this.showSuccessMsg(data)
       });


    }


  }

  showSuccessMsg(msg){
    console.log(msg);
     this.statusMsg="documento salvato con successo";
    this.updateMessage();

  }

}
